import { LazyAction, LazyModule } from 'owa-bundling-light';
import { lazyActionWithErrorHandler } from 'mini-error-handler/lib/utils/lazyActionWithErrorHandler';
import { LoadConversationReadingPaneState } from './actions/loadConversationReadingPane';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "ReadingPaneStore" */ './lazyIndex')
);
const lazyModuleLoadItemReadingPane = new LazyModule(
    () => import(/* webpackChunkName: "ReadingPaneStore" */ './lazyIndexLoadItemReadingPane')
);

export const lazyLoadConversationReadingPane = new LazyAction(
    lazyModule,
    m => m.loadConversationReadingPane
);

export const lazyLoadItemReadingPane = new LazyAction(
    lazyModuleLoadItemReadingPane,
    m => m.loadItemReadingPane
);

export const lazyLoadedItemReadingPaneErrorHandled = lazyActionWithErrorHandler(
    lazyLoadItemReadingPane
);

export const lazyLoadedConversationReadingPaneErrorHandled = lazyActionWithErrorHandler(
    lazyLoadConversationReadingPane
);

export { LoadConversationReadingPaneState };
